var map = {
	"./act": 1498,
	"./act.ts": 1498,
	"./gmat": 1499,
	"./gmat.ts": 1499,
	"./gre": 1500,
	"./gre.ts": 1500,
	"./ielts": 1501,
	"./ielts.ts": 1501,
	"./ielts_general_training": 1502,
	"./ielts_general_training.ts": 1502,
	"./lsat": 1503,
	"./lsat.ts": 1503,
	"./mcat": 1504,
	"./mcat.ts": 1504,
	"./sat": 1505,
	"./sat.ts": 1505,
	"./toefl": 1506,
	"./toefl.ts": 1506
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 2510;
module.exports = webpackAsyncContext;